import { Flex } from '@workday/canvas-kit-react/layout';
import { system } from '@workday/canvas-tokens-web';
import { useIntl } from '@workday/i18n/nextgen';
import React from 'react';
import { Canvas } from 'modules/common/Canvas/index';

interface ExternalLinkWarningModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const ExternalLinkWarningModal: React.FC<ExternalLinkWarningModalProps> = ({ onConfirm, onCancel }) => {
  const intl = useIntl();

  const WARNING_MESSAGE = intl.formatMessage({
    id: 'core.ExternalLinkWarningModal.warningMessage',
    defaultMessage: 'You are now leaving the Developer Site. Are you sure you want to proceed?',
    description: 'Main warning message explaining that the user is leaving the Developer Site',
  });

  const CONFIRMATION_MESSAGE = intl.formatMessage({
    id: 'core.ExternalLinkWarningModal.confirmationMessage',
    defaultMessage: 'Clicking "Yes" will open this link in a new window and take you away from the Developer Site.',
    description: 'Additional message explaining what will happen when the user confirms',
  });

  const CANCEL_BUTTON = intl.formatMessage({
    id: 'core.ExternalLinkWarningModal.cancelButton',
    defaultMessage: 'No, stay here',
    description: 'Text for the cancel button that keeps the user on the current page',
  });

  const CONFIRM_BUTTON = intl.formatMessage({
    id: 'core.ExternalLinkWarningModal.confirmButton',
    defaultMessage: 'Yes, proceed',
    description: 'Text for the confirm button that allows the user to navigate to the external link',
  });

  return (
    <Canvas.Modal.Body data-testid='external-link-warning-modal'>
      <Flex flexDirection='column' gap={system.space.x4}>
        <Canvas.Subtext as='p' size='large'>
          {WARNING_MESSAGE}
        </Canvas.Subtext>

        <Canvas.Subtext as='p' size='large'>
          {CONFIRMATION_MESSAGE}
        </Canvas.Subtext>
      </Flex>

      <Flex gap={system.space.x4} justifyContent='flex-end' marginTop={system.space.x8}>
        <Canvas.SecondaryButton data-testid='external-link-warning-cancel' onClick={onCancel}>
          {CANCEL_BUTTON}
        </Canvas.SecondaryButton>
        <Canvas.PrimaryButton data-testid='external-link-warning-confirm' onClick={onConfirm}>
          {CONFIRM_BUTTON}
        </Canvas.PrimaryButton>
      </Flex>
    </Canvas.Modal.Body>
  );
};

export default ExternalLinkWarningModal;
